import axios from "axios";
import { getTokenHeader } from "@/helpers/commonHelper";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "AdManagerFormatEditDialog",
  props: {
    dialog: { type: Boolean, default: false },
    editedItem: { type: Object, default: null },
    currentPrincipal: { type: String, default: "" },
    dimensionOptions: { type: Array, default: () => [] }
  },
  data() {
    return {
      innerDialog: false,
      localItem: this.blank(),
      valid: false,
      saving: false,
      mainPeacock: "#00636C",
      positiveInt: v =>
        ((v === 0 || v > 0) && Number.isInteger(+v)) || "Bitte ganze Zahl ≥ 0",
      optionalPositiveInt: v =>
        v === null ||
        v === "" ||
        ((v === 0 || v > 0) && Number.isInteger(+v)) ||
        "Ganze Zahl ≥ 0 oder leer"
    };
  },
  watch: {
    dialog(val) {
      this.innerDialog = val;
      if (val) {
        this.fillData();
      }
    }
  },
  methods: {
    blank() {
      return {
        principal_id: "",
        name: "",
        desktop: { dimensions: "full_width", width: null, height: null },
        mobile: { dimensions: null, width: null, height: null }
      };
    },
    fillData() {
      const base = this.editedItem
        ? JSON.parse(JSON.stringify(this.editedItem))
        : this.blank();
      if (!base.desktop) base.desktop = { width: null, height: null };
      if (!base.mobile) base.mobile = { width: null, height: null };
      base.principal_id = this.currentPrincipal;
      this.localItem = base;
      this.$nextTick(() => this.$refs.form?.resetValidation());
    },
    async onSave() {
      const ok = await this.$refs.form.validate();
      if (!ok) return;

      // Minimal-Validierung: Name + Desktop WxH müssen gesetzt sein
      if (
        !this.localItem.name ||
        (this.localItem.desktop.dimensions === "manual" &&
          (this.localItem.desktop.width == null ||
            this.localItem.desktop.height == null))
      ) {
        this.$toast?.error?.("Bitte Name und Desktop-Maße angeben");
        return;
      }

      this.saving = true;
      const headers = getTokenHeader();

      // Payload-Shape an API anpassen falls nötig
      const payload = {
        ...this.localItem,
        principal_id: this.currentPrincipal
      };

      if (!payload._id) delete payload._id;

      try {
        if (this.localItem._id) {
          await axios.put(
            env.ad_manager_api_client_url + "ad/formats/" + this.localItem._id,
            payload,
            { headers }
          );
        } else {
          const res = await axios.post(
            env.ad_manager_api_client_url + "ad/formats",
            payload,
            { headers }
          );
          this.localItem._id = res.data?._id || this.localItem._id;
        }
        this.$emit("afterSave");
        this.onCancel();
      } catch (e) {
        this.$toast?.error?.("Speichern fehlgeschlagen");
        console.error(e);
      } finally {
        this.saving = false;
      }
    },
    onCancel() {
      this.$emit("close");
      this.$emit("update:dialog", false);
    }
  }
};
